import { Chip, styled } from '@mui/material';
import { ComponentProps } from 'react';

export const StyledRemixerTag = (props: ComponentProps<typeof Chip>) => (
  <Chip variant="outlined" {...props} />
);

export const StyledSecondaryTag = styled(StyledRemixerTag)(({ theme }) => ({
  color: theme.palette.warning.main,
  borderColor: theme.palette.warning.main,
}));
